import { Button, Col, Form, Input, Row } from "antd";
import { FC, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Icon from "../../../assets/icons/icon";
import { renderErrorMessage } from "../../../components/messages/errorMessage";
import _t from "../../../lang/translate";
import { getPath } from "../../../routes/appRoutes";
import { login } from "../../../services/authService";
import { trackKlaviyoLogin } from "../../../services/klaviyoTrackerService";
import log from "../../../services/logService";
import { LocationStateType } from "../../../types/appTypes";
import { LoginType } from "../../../types/loginTypes";
import { isEmbedded } from "../../../utilities/isEmbedded";

interface LoginFormProps {
  title: string;
}

const DMF_PRO_ORIGIN = process.env.REACT_APP_DMF_PRO_ORIGIN
const DMF_PRO_LOGIN_PATH = process.env.REACT_APP_DMF_PRO_LOGIN_PATH
const DMF_PRO_LOGIN_URL = (DMF_PRO_ORIGIN ?? "") + (DMF_PRO_LOGIN_PATH ?? "");
const LoginForm: FC<LoginFormProps> = ({ title }) => {
  const history = useHistory();
  const location = useLocation<LocationStateType>();
  const [loading, setLoading] = useState<boolean>(false);

  const handleLogin = async (values: LoginType) => {
    try {
      setLoading(true);
      await login(values);
      const oldState = location.state;

      window.history.replaceState(null, "", getPath("home"));
      window.location.href = oldState?.from ? oldState?.from?.pathname : "/";
      trackKlaviyoLogin(values.email)
    } catch (error) {
      log({ from: "login page", error });
      renderErrorMessage(error)
    } finally {
      setLoading(false);
    }
  };

  const handleForgetPassword = () => {
    const path = getPath("forgotPassword");
    history.push(path);
  };

  return (
    <Form<LoginType> layout="vertical" name="loginForm" requiredMark={false} onFinish={handleLogin}>
      {!isEmbedded() && (
        <div className="text-primary">
          <Icon size="medium" name="shield-checkmark-outline" />
          <span className="ml-03 text-smaller letter-spacing-wider text-upper text-medium">DMF Administration</span>
        </div>
      )}
      <h1>
        {title}
        {!isEmbedded() && (
          <p className="text-small text-gray text-normal">Log ind med din medarbejderkonto</p>
        )}
      </h1>

      {!isEmbedded() && (
        <a className="dmf-pro-login-link" href={DMF_PRO_LOGIN_URL}>
          <Row gutter={[16, 16]} align="top">
            <Col>
              <div className="icon-wrapper">
                <Icon className="text-primary" size="large" name="buildings" />
              </div>
            </Col>
            <Col>
              <h4 className="mb-0">{_t("are_you_a_dealer")}?</h4>
              <span className="text-smaller text-gray mb-0">Forhandlerportalen er flyttet til DMF Pro.</span>
              <span className="inner-link">Log ind på DMF Pro <Icon name="arrow-forward-outline" /></span>
            </Col>
          </Row>
        </a>
      )}

      <Form.Item name="email" rules={[{ required: true, type: "email" }]} label={_t("email")}>
        <Input autoFocus disabled={loading} prefix={<Icon name="person-outline" />} />
      </Form.Item>
      <Form.Item name="password" rules={[{ required: true }]} label={_t("password")}>
        <Input.Password disabled={loading} prefix={<Icon name="lock-closed-outline" />} />
      </Form.Item>
      <Row align="middle" justify="space-between">
        <Col>
          <Button className="underline-style p-0" type="link" disabled={loading} onClick={handleForgetPassword}>
            {_t("forgot_password")}
          </Button>
        </Col>
      </Row>
      <Button disabled={loading} className="fancy-btn mt-1" htmlType="submit" type="primary" block>
        {_t("log_in")}
      </Button>
      {/*
      <div className="text-center mt-2">
        {_t("dont_have_account")}&nbsp;
        <Button type="link" className="underline-style p-0">
          <Link to={getPath("signUp")}>{_t("create_account")}</Link>
        </Button>
      </div>
      */}
    </Form>
  );
};

export default LoginForm;
